import {ChainHubById, ObserverHub} from 'sopix/utils/observers'

export const graphqlCanIncludeField = new ChainHubById()

export const graphqlCanIncludeTable = new ChainHubById()

export const graphqlConstructorOptions = new ChainHubById()

export const graphqlOnError = new ObserverHub()
